/* eslint-env jquery */
const $ = jQuery.noConflict();

'use strict';
const EloaDownloadPDF = {
	/*-------------------------------------------------------------------------------
		# Initialize
	-------------------------------------------------------------------------------*/
	init: function() {
		this.downloadPDF();
	},

	downloadPDF: function() {
		$('.js-eloa-submit').click(()=>{
			const ticketNumber = $('[name="your-ticket"]').val();
			localStorage.setItem('ticketNumber', JSON.stringify(ticketNumber));
			const text = $('div:hidden.hidden-div').text();
			localStorage.setItem('text', JSON.stringify(text));
			const customerName = $('[name="customer-name"]').val();
			localStorage.setItem('customerName', customerName);
			const yourTel = $('[name="your-tel"]').val();
			localStorage.setItem('yourTel', yourTel);
			const customerAddress = $('[name="customer-address"]').val();
			localStorage.setItem('customerAddress', customerAddress);
			const yourCity = $('[name="your-city"]').val();
			localStorage.setItem('yourCity', yourCity);
			const yourState = $('[name="your-state"]').val();
			localStorage.setItem('yourState', yourState);
			const yourZip = $('[name="your-zip"]').val();
			localStorage.setItem('yourZip', yourZip);
			const yourAcc = $('[name="your-acc"]').val();
			localStorage.setItem('yourAcc', yourAcc);
			const yourPin = $('[name="your-pin"]').val();
			localStorage.setItem('yourPin', yourPin);
			const ported = $('[name="ported"]').val();
			localStorage.setItem('ported', ported);
			const fullName = $('[name="full-name"]').val();
			localStorage.setItem('fullName', fullName);
			const customerDate = $('[name="customer-date"]').val();
			localStorage.setItem('customerDate', customerDate);
			const sigCanvas = $('#sig-image').attr('src');
			localStorage.setItem('sigCanvas', sigCanvas);

			const pack = 	{
				ticketNumber: ticketNumber,
				text: text,
				customerName: customerName,
				yourTel: yourTel,
				customerAddress: customerAddress,
				yourCity: yourCity,
				yourState: yourState,
				yourZip: yourZip,
				yourAcc: yourAcc,
				yourPin: yourPin,
				ported: ported,
				fullName: fullName,
				customerDate: customerDate,
				sigCanvas: sigCanvas
			};
			localStorage.setItem('EloaForm', JSON.stringify(pack));

			$('.btn-download-js').closest('form').find('input[name=form]').val(localStorage.getItem('EloaForm'));

		});

		$('.btn-download-js').click(() => {
			const form = $('input[name=form]').val();
			$.ajax({
				type: 'post',
				url: 'eloa-template-download.php',
				data: {
					form: form,
				},
			});
		});
	}
};

export default EloaDownloadPDF;
